export default function renderIcon({ color = '#ffffff', width = '20.154', height = '20.154' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20.154 20.154">
      <path id="Subtraction_18" data-name="Subtraction 18" d="M10.941,19.154H8.212l-1.1-2.32-.927-.384-2.417.864L1.84,15.383,2.7,12.966,2.32,12.04,0,10.941V8.212l2.32-1.1L2.7,6.187,1.84,3.77,3.77,1.84,6.188,2.7l.925-.383L8.212,0h2.729l1.1,2.321.925.383,2.418-.864,1.931,1.93L16.45,6.187l.384.927,2.32,1.1v2.729l-2.32,1.1-.384.927.864,2.417-1.931,1.931-2.417-.864-.927.384-1.1,2.319ZM9.526,6.57a2.956,2.956,0,1,0,2.956,2.956A2.96,2.96,0,0,0,9.526,6.57Z" transform="translate(0.5 0.5)" fill="none" stroke={color} strokeWidth="1" />
    </svg>

  )
}
